import { Component } from '@angular/core';
import {
  EmperorCardHeaderColor,
  EmperorDialogConfig,
  EmperorDialogRefService,
  EmperorUIButtonTypes,
} from '@boldpenguin/emperor-presentational';
import { LegalFileService } from 'src/app/features/signup/services/legal-file.service';

@Component({
  selector: 'app-pdf-dialog',
  templateUrl: './pdf-dialog.component.html',
  styleUrls: ['./pdf-dialog.component.scss'],
})
export class PdfDialogComponent {
  readonly EmperorCardHeaderColor = EmperorCardHeaderColor;
  pdfSrc: string;
  title: string;
  readonly EmperorButtonType = EmperorUIButtonTypes;

  constructor(
    config: EmperorDialogConfig,
    private dialogRefService: EmperorDialogRefService,
    private legalFileService: LegalFileService,
  ) {
    this.pdfSrc = config.data.pdfSrc;
    this.title = config.data.title;
  }

  download() {
    this.legalFileService.download(this.pdfSrc);
  }

  onClose() {
    this.dialogRefService.close();
  }
}
